exports.SYMBOLS_BY_CODE = {
  CAD: '$',
  CNY: '¥',
  EUR: '€',
  GBP: '£',
  INR: '₹',
  MXN: '$',
  USD: '$',
  CLP: '$',
  BRL: 'R$',
}

exports.CODES_BY_LOCALE = {
  'en-CA': 'CAD',
  'en-GB': 'GBP',
  'en-IE': 'EUR',
  'en-US': 'USD',
  'es-ES': 'EUR',
  'es-MX': 'MXN',
  'hi-IN': 'INR',
  'fr-FR': 'EUR',
  'zh-CN': 'CNY',
  'es-US': 'USD',
  'es-CL': 'CLP',
  'pt-BR': 'BRL',
  'fr-CA': 'CAD',
}
